import { api } from "./client";

export const getOrganizations = (page = 1, pageSize = 20, search = "") => {
  return api.get("/organizations/", {
    params: {
      page,
      page_size: pageSize,
      search,
    },
  });
};

export const getOrganization = (id) => api.get(`/organizations/${id}/`);

export const createOrganization = (payload) =>
  api.post("/organizations/", payload);

export const patchOrganization = (id, payload) =>
  api.patch(`/organizations/${id}/`, payload);

export const getOrganizationStorefront = (id) =>
  api.get(`/organizations/${id}/storefront/`);

export const patchOrganizationStorefront = (id, payload) =>
  api.patch(`/organizations/${id}/storefront/`, payload);

export const uploadOrganizationMedia = (id, kind, file) => {
  const form = new FormData();
  form.append("kind", kind);
  form.append("file", file);
  return api.post(`/organizations/${id}/storefront/media/`, form, {
    headers: { "Content-Type": undefined },
  });
};

export const getOrganizationPaymentAccount = (id) =>
  api.get(`/organizations/${id}/payment-account/`);

export const putOrganizationPaymentAccount = (id, payload) =>
  api.put(`/organizations/${id}/payment-account/`, payload);

export const getOrganizationMemberships = (id) =>
  api.get(`/organizations/${id}/memberships/`);

export const inviteOrganizationMember = (id, payload) =>
  api.post(`/organizations/${id}/memberships/`, payload);

export const patchOrganizationMember = (id, membershipId, payload) =>
  api.patch(`/organizations/${id}/memberships/${membershipId}/`, payload);

export const deleteOrganizationMember = (id, membershipId) =>
  api.delete(`/organizations/${id}/memberships/${membershipId}/`);

/** @deprecated Prefer getOrganizations */
export const getCompanies = getOrganizations;
